import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Pin';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2197 3.21967C15.5126 2.92678 15.9874 2.92678 16.2803 3.21967L20.7803 7.71967C21.0732 8.01256 21.0732 8.48744 20.7803 8.78033L16.4055 13.1551L14.2115 19.7372C14.1293 19.9838 13.9253 20.1702 13.6723 20.2299C13.4193 20.2897 13.1535 20.2141 12.9697 20.0303L9 16.0607L4.28033 20.7803C3.98744 21.0732 3.51256 21.0732 3.21967 20.7803C2.92678 20.4874 2.92678 20.0126 3.21967 19.7197L7.93934 15L3.96967 11.0303C3.78587 10.8465 3.71034 10.5807 3.77006 10.3277C3.82978 10.0747 4.01623 9.87069 4.26283 9.78849L10.8449 7.59448L15.2197 3.21967ZM15.75 4.81066L11.7803 8.78033C11.698 8.86266 11.5976 8.92469 11.4872 8.96151L5.88842 10.8278L13.1722 18.1116L15.0385 12.5128C15.0753 12.4024 15.1373 12.302 15.2197 12.2197L19.1893 8.25L15.75 4.81066Z" fill="currentColor"/>
  </svg>
`;

const PinIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.2197 3.21967C15.5126 2.92678 15.9874 2.92678 16.2803 3.21967L20.7803 7.71967C21.0732 8.01256 21.0732 8.48744 20.7803 8.78033L16.4055 13.1551L14.2115 19.7372C14.1293 19.9838 13.9253 20.1702 13.6723 20.2299C13.4193 20.2897 13.1535 20.2141 12.9697 20.0303L9 16.0607L4.28033 20.7803C3.98744 21.0732 3.51256 21.0732 3.21967 20.7803C2.92678 20.4874 2.92678 20.0126 3.21967 19.7197L7.93934 15L3.96967 11.0303C3.78587 10.8465 3.71034 10.5807 3.77006 10.3277C3.82978 10.0747 4.01623 9.87069 4.26283 9.78849L10.8449 7.59448L15.2197 3.21967ZM15.75 4.81066L11.7803 8.78033C11.698 8.86266 11.5976 8.92469 11.4872 8.96151L5.88842 10.8278L13.1722 18.1116L15.0385 12.5128C15.0753 12.4024 15.1373 12.302 15.2197 12.2197L19.1893 8.25L15.75 4.81066Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: PinIcon,
  IconSvg: IconSvg
} as IconType;
